export const ADD_TENANTS = 'ADD_TENANTS';
